import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  //页面
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home/index.vue"),
  },
  //主页面
  {
    path: "/",
    name: "Home",
    //redirect为重定向，重定向到它的子路由/welcome
    redirect: "/welcome",
    component: () => import("../views/Home/index.vue"),
  },
  /**智为云菜单——集团共享  **************************************************************/
  //无权访问页面
  {
    path: "/NoAccess",
    name: "NoAccess",
    component: () =>
      import("../views/GroupShared/NoAccess.vue"),
    meta: {
      title: "无权访问",
    },
  },
  //经营管理待更新
  {
    path: "/BumUpdated",
    name: "BumUpdated",
    component: () =>
      import("../views/GroupShared/CustomerManage/BumUpdated/index.vue"),
    meta: {
      title: "经营管理待更新",
    },
  },
  //集团客户列表
  {
    path: "/GroupCustomerList",
    name: "GroupCustomerList",
    component: () =>
      import("../views/GroupShared/CustomerManage/GroupCustomerList/index.vue"),
    meta: {
      title: "集团客户列表",
    },
  },
  //推送记录
  {
    path: "/PushRecords",
    name: "PushRecords",
    component: () =>
      import("../views/GroupShared/CustomerManage/PushRecords/index.vue"),
    meta: {
      title: "推送记录",
    },
  },
  //共享发送记录
  {
    path: "/ShareSended",
    name: "ShareSended",
    component: () =>
      import("../views/GroupShared/CustomerManage/ShareSended/index.vue"),
    meta: {
      title: "共享发送记录",
    },
  },
  //共享接收记录
  {
    path: "/ShareReceived",
    name: "ShareReceived",
    component: () =>
      import("../views/GroupShared/CustomerManage/ShareReceived/index.vue"),
    meta: {
      title: "共享接收记录",
    },
  },
  //客户数据
  {
    path: "/CustomerData",
    name: "CustomerData",
    component: () =>
      import("../views/GroupShared/DataStatistics/CustomerData/index.vue"),
    meta: {
      title: "客户数据",
    },
  },
  //变更日志
  {
    path: "/ChangeLog",
    name: "ChangeLog",
    component: () =>
      import("../views/GroupShared/BasicSettings/ChangeLog/index.vue"),
    meta: {
      title: "变更日志",
    },
  },
  //集团管理
  {
    path: "/GroupManagement",
    name: "GroupManagement",
    component: () =>
      import("../views/GroupShared/BasicSettings/GroupManagement/index.vue"),
    meta: {
      title: "集团管理",
    },
  },
  //对码管理
  {
    path: "/CodeManagement",
    name: "CodeManagement",
    component: () =>
      import("../views/GroupShared/BasicSettings/CodeManagement/index.vue"),
    meta: {
      title: "对码管理",
    },
  },
];
const router = new VueRouter({
  routes,
});

//挂载路由导航守卫
router.beforeEach((to, from, next) => {
  //如果是访问登录页直接放行
  if (to.path == "/") return next();
  //如果访问其他页面没有token存在就跳转到登录页
  // const tokenStr = window.sessionStorage.getItem("token");
  // if (!tokenStr) return next("/");
  //如果有token存在直接放行
  next();
});

export default router;
